// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"4826da8b","256":"89a14ba5","297":"2f163000","453":"8279b45c","489":"2d44c84c"}[chunkId] + ".chunk.js";
};